module.exports = __webpack_public_path__ + "img/20_129.d4c30088.png";